package cc.easyandroid.easycompose.mvi.utils.internal


fun <T : Any> AtomicRef<T?>.initialize(value: T) {
    if (!compareAndSet(null, value)) {
        error("Value is already initialized: $this")
    }
}

fun <T : Any> AtomicRef<T?>.requireValue(): T =
    requireNotNull(value) { "Value was not initialized" }
